import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppraisalService } from '../../services/appraisal.service';
import { AuthService } from '../../services/auth.service';
import { useToast } from '../../context/ToastContext';
import { IReviewSummary } from '../../interfaces/appraisal.interface';
import ReviewTable from './ReviewTable';

/** The signed-in employee's own appraisals, in active and closed cycles. */
const MyAppraisals: React.FC = () => {
    const toast = useToast();
    const { t } = useTranslation('appraisal');
    const institutionId = AuthService.getSelectedInstitution()!;
    const [reviews, setReviews] = useState<IReviewSummary[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                setReviews(await AppraisalService.myReviews(institutionId));
            } catch (err) {
                toast.showApiError(err, t('errors.loadReviews'));
            } finally {
                setLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [institutionId]);

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>{t('myAppraisals.title')}</Typography>
            <ReviewTable reviews={reviews} loading={loading} mode="mine" emptyText={t('myAppraisals.empty')} />
        </Box>
    );
};

export default MyAppraisals;
